<template>
  <div class="box4">
   <img src="../../../assets/coursePage/trainer/04.png"/>
  </div>
</template>

<script>


export default {
 
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box4 {
  width: 100%;
 img{
  width: 100%;
  display: block;
 }
  
}
</style>
